// extracted by mini-css-extract-plugin
module.exports = {"button-content":"TalkToSales_button-content__JtkTk","arrow":"TalkToSales_arrow__9LP_4","text":"TalkToSales_text__3ilY2"};